export default ()=><svg width="46" height="46" viewBox="0 0 46 46" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg" strokeLinejoin="round" strokeMiterlimit="10">
<path d="M21.7222 25.5556H15.9722V35.7778H21.7222V25.5556Z"  />
<path d="M30.6667 25.5556H25.5556V30.0278H30.6667V25.5556Z"/>
<path d="M33.8611 20.4444L12.1389 20.4446V19.8055L22.3611 9.58331L33.8611 19.8055V20.4444Z"/>
<path d="M33.8611 20.4444H12.1389V35.7777H33.8611V20.4444Z"/>
<path d="M18.5278 13.4166L15.3333 16.6111V10.8611H18.5278V13.4166Z"/>
</svg>
